import format from "date-fns/format";
import { connect } from "react-redux";
import { Actions as ADMINACTIONS } from "../../store/actions/adminActions";
import { PencilIcon } from "@heroicons/react/20/solid";

const GlobalUserNotificationRow = ({ notification, openModal, typeOptions}) => {
	return (
		<tr>
			<td className="text-left">{notification?.title}</td>
			<td style={{ textAlign: "center" }}>
				{notification?.description}
			</td>
			<td style={{ textAlign: "center" }}>
				{
					notification?.effectiveDate
						? format(new Date(notification?.effectiveDate), "do MMM yyyy")
						: ""
				}
			</td>
			<td style={{ textAlign: "center" }}>
				{typeOptions.find((option) => option.value === notification?.type)?.label}
			</td>
			<td>
					<div
						className="btn btn-xs btn-default"
						type="button"
						//onClick={() => copyToClipboard(client.advisor)}
						style={{ marginRight: "0.5rem" }}
						onClick={() => openModal(true, notification?.id)}
					>
						<PencilIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: "3px" }}
						/>
					</div>
			</td>
		</tr>
	);
};

const mapStateToProps = (state) => {
	const typeOptions = [{ value: "notification", label: "Notification" }, { value: "update", label: "Update" }];

	return {
		typeOptions,
	};
	
};

const mapDispatchToProps = (dispatch) => ({
	openModal: (status, notificationId) => dispatch(ADMINACTIONS.getCreateNotificationModal(status, notificationId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalUserNotificationRow);
